import React, { Component, PropTypes } from "react"
// material-ui
import { Card, CardActions, CardHeader, CardText } from "material-ui/Card"
import Divider from "material-ui/Divider"
import FlatButton from "material-ui/FlatButton"
// app
import Note from "./note.js"
import SaveCancel from "components/common/buttons/SaveCancel"
import TextField from "components/common/TextField"


const initialState = {
    add: false,
    value: ""
}

class PersonNotes extends Component {
    constructor(props) {
        super(props)

        this.state = initialState

        this.add = () => this.setState({ add: true })
        this.cancel = () => this.setState(initialState)
        this.save = () => {
            this.props.onAdd(this.state)
            this.setState(initialState)
        }

        this.handleValueChange = (value) => this.setState({ value })
    }

    render() {
        return (
            <Card className="card">
                <CardHeader
                    title="Notes"
                    style={{ paddingBottom: 0 }}
                />
                <CardText>
                    {
                        this.props.data.map((note, i) => {
                            return <div key={ note.get("id") }>
                                { i !== 0 ? <Divider /> : null }
                                <Note
                                    name={ note.get("name") }
                                    date={ note.get("ts") }
                                    text={ note.get("value") }
                                />
                            </div>
                        })
                    }
                    { this.state.add ?
                        <TextField
                            autoFocus={ true }
                            label="Please enter your thoughts"
                            maxLength={ 500 }
                            rows={ 2 }
                            rowsMax={ 2 }
                            multiLine={ true }
                            onChange={ this.handleValueChange }
                        />
                        :
                        null 
                    }
                </CardText>
                <CardActions>
                    { this.state.add ?
                        <SaveCancel
                            onSave={ this.save }
                            onCancel={ this.cancel }
                            disabled={ this.state.value === "" }
                        />
                        :
                        <FlatButton
                            label="Add Note"
                            primary={ true }
                            onTouchTap={ this.add }
                        />
                    }
                </CardActions>
            </Card>
        )
    }
}

PersonNotes.propTypes = {
    data: PropTypes.object.isRequired, // immutable.List()
    onAdd: PropTypes.func.isRequired
}

export default PersonNotes


/** WEBPACK FOOTER **
 ** ./src/components/person/Notes/person-notes.js
 **/